import { ApiState, Action } from '../../../../types';
import { serviceReducer } from '../../../../shared/hooks/serviceReducer';
import { TimelineContainer } from '../../../../services/types/Timeline';

const timelineReducer = (
  state: ApiState<TimelineContainer, number>,
  action: Action<TimelineContainer, number>
): ApiState<TimelineContainer, number> => serviceReducer(state, action);

export default timelineReducer;
